
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RepoDsn',
  data() {
    return {
      isDSNHidden: true
    }
  },
  props: {
    dsn: {
      type: String,
      default: ''
    },
    canRegenerateDsn: {
      type: Boolean,
      required: true
    }
  }
})
